export default __webpack_public_path__ + "static/media/blue_white_vaccinate.66fd1951.svg";